import React, { useState, useEffect } from 'react';


const CommuneHeader = ({ token, dashData }) => {
    const [currentTime, setCurrentTime] = useState(new Date());
    const [elapsed, setElapsed] = useState('');

    useEffect(() => {
        const t = setInterval(() => {
            setCurrentTime(new Date());
            if (dashData?.pcs_activation_time && dashData?.event_active !== false) {
                const start = new Date(dashData.pcs_activation_time);
                const diff = Math.floor((Date.now() - start.getTime()) / 1000);
                if (diff >= 0) {
                    const h = Math.floor(diff / 3600);
                    const m = Math.floor((diff % 3600) / 60);
                    const s = diff % 60;
                    setElapsed(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`);
                }
            }
        }, 1000);
        return () => clearInterval(t);
    }, [dashData?.pcs_activation_time, dashData?.event_active]);

    return (
        <div className="page-header">
            <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex items-center gap-3">
                                        <div><h1 className="page-title">Dashboard Commune</h1><p className="page-subtitle">Synthese de la situation</p></div>
                </div>
                <div className="flex items-center gap-3 flex-wrap">
                    {/* Current Time */}
                    <div className="glass-panel px-4 py-2 rounded-lg" data-testid="commune-current-time">
                        <p className="text-[10px] text-zinc-500 uppercase tracking-wider">Heure actuelle</p>
                        <p className="font-mono text-3xl text-white font-bold leading-tight">
                            {currentTime.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
                        </p>
                        <p className="text-[11px] text-zinc-500 mt-0.5">{currentTime.toLocaleDateString('fr-FR', { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric' })}</p>
                    </div>
                    {/* PCS Chrono OR Inactive */}
                    {dashData?.pcs_activation_time && dashData?.event_active !== false ? (
                        <div className="glass-panel px-4 py-2 rounded-lg border border-red-500/30" data-testid="commune-pcs-chrono">
                            <p className="text-[10px] text-red-400 uppercase tracking-wider flex items-center gap-1">
                                <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse inline-block"></span> PCS actif
                            </p>
                            <p className="font-mono text-3xl text-red-400 font-bold leading-tight">{elapsed || '00:00:00'}</p>
                            <p className="text-[11px] text-zinc-500 mt-0.5">depuis {new Date(dashData.pcs_activation_time).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}</p>
                        </div>
                    ) : (
                        <div className="glass-panel px-4 py-2 rounded-lg border border-zinc-700/50" data-testid="commune-pcs-inactive">
                            <p className="text-[10px] text-zinc-500 uppercase tracking-wider flex items-center gap-1">
                                <span className="w-2 h-2 rounded-full bg-zinc-600 inline-block"></span> PCS
                            </p>
                            <p className="font-mono text-xl text-zinc-400 font-bold leading-tight mt-0.5">Desactive</p>
                            <p className="text-[11px] text-zinc-600 mt-0.5">Aucun evenement</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CommuneHeader;
